/**
 * App-bar entry point for the home health demo presenter layer. Renders nothing unless
 * the layer is enabled for this organization or browser (see demoEnabled.ts).
 */
import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import TheaterComedyIcon from "@mui/icons-material/TheaterComedy";
import { useLocation } from "react-router-dom";
import { useOrganization } from "~/providers/GraphqlProvider";
import { applyQueryOverride, isHomeHealthDemoEnabled } from "./demoEnabled";
import { PRESENTER_TOGGLE_ATTR, PresenterDrawer } from "./presenter/PresenterDrawer";

export function HomeHealthDemoAppBarButton() {
  const { organizationName } = useOrganization();
  const { search } = useLocation();
  const [enabled, setEnabled] = useState(() => isHomeHealthDemoEnabled(organizationName));
  const [open, setOpen] = useState(false);

  useEffect(() => {
    applyQueryOverride(search);
    setEnabled(isHomeHealthDemoEnabled(organizationName));
  }, [search, organizationName]);

  if (!enabled) return null;

  return (
    <>
      <Button
        variant="outlined"
        color="inherit"
        startIcon={<TheaterComedyIcon />}
        onClick={() => setOpen((v) => !v)}
        {...{ [PRESENTER_TOGGLE_ATTR]: true }}
        sx={{
          borderColor: "rgba(255, 255, 255, 0.5)",
          "&:hover": { borderColor: "rgba(255, 255, 255, 0.8)", backgroundColor: "rgba(255, 255, 255, 0.1)" },
        }}
      >
        Presenter
      </Button>
      <PresenterDrawer open={open} onClose={() => setOpen(false)} onDisabled={() => setEnabled(false)} />
    </>
  );
}
